import { FaLock, FaTools } from "react-icons/fa";
import { MdWindow } from "react-icons/md";

const whyChooseUs = {
    sub: "Why Choose Us",
    heading: "Elevating Homes, Enhancing Security.",
    content: "At WindowCraft, we're dedicated to elevating the aesthetics and security of your home with our premium windows and doors.",
    points: [
        {
            id: 1,
            icon: <MdWindow />, // Window icon
            title: "Wide Range of Solutions",
            content: "We offer a wide range of window and door solutions tailored to suit your unique needs, ensuring the perfect fit for your home.",
        },
        {
            id: 2,
            icon: <FaLock />, // Lock icon
            title: "Enhanced Security Features",
            content: "Our products come equipped with state-of-the-art security features to provide you with peace of mind, knowing your home is well-protected.",
        },
        {
            id: 3,
            icon: <FaTools />, // Tools icon
            title: "Professional Installation",
            content: "Our team of experts ensures precise and professional installation of your windows and doors, guaranteeing optimal performance and longevity.",
        },
    ]
};

export default whyChooseUs;